import axios from 'axios'

const init = () => {
  const instance = axios.create({
    baseURL: `https://zipcloud.ibsnet.co.jp/api/`,
    headers: {
      common: {
        accept: 'application/json',
      },
    },
  })

  return instance
}

export default init()
